<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <router-link class="navbar-brand" to="/" v-if="userEntidade">
        <img
          src="@/assets/ft-logo-nav.png"
          alt="Falcon Tech"
          width="50"
          class="d-inline-block align-text-top"
        />
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav me-auto">
          <li class="nav-item">
            <router-link
              class="nav-link"
              to="/analises-ranking"
              v-if="userEntidade"
              >Ranking</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              to="/analises-capag"
              v-if="userEntidade"
              >CAPAG</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/balancetes" v-if="userEntidade"
              >Balancete</router-link
            >
          </li>
          <li class="nav-item" v-if="userEntidade">
            <router-link 
            :class="['nav-link', { 'disabled': hasPendencia }]"
            to="/upload" 
            v-if="userEntidade"
              >Enviar arquivo</router-link
            >
          </li>
        </ul>
        <ul class="navbar-nav">
          <li class="nav-item municipio-nome" v-if="userEntidade">
            <p>{{ nomeMunicipio }}{{ isDemo ? " (DEMO)" : "" }}</p>
            <router-link
              class="nav-link trocar-link"
              to="/selecaoEntidades"
              v-if="isMunicipioChangeable"
              >(trocar)</router-link
            >
          </li>
          <!-- Avatar Dropdown Menu -->
          <li
            class="nav-item dropdown"
            v-if="user"
            @mouseenter="handleAvatarMouseEnter"
            @mouseleave="handleAvatarMouseLeave"
          >
            <a
              class="nav-link dropdown-toggle avatar-dropdown"
              href="#"
              id="avatarDropdown"
              role="button"
              aria-expanded="false"
              @click.prevent
            >
              <div class="avatar-circle">
                <i class="bi bi-person-fill"></i>
              </div>
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end"
              aria-labelledby="avatarDropdown"
              :class="{ show: showAvatarDropdown }"
            >
              <!-- <li class="dropdown-header">Usuário</li>
              <li><hr class="dropdown-divider"></li> -->
              <li v-if="userAdmin && userEntidade">
                <router-link class="dropdown-item" to="/users">
                  <i class="bi bi-people-fill me-2"></i>Usuários
                </router-link>
              </li>
              <li v-if="userAdmin && userEntidade">
                <router-link class="dropdown-item" to="/municipios">
                  <i class="bi bi-building me-2"></i>Municípios
                </router-link>
              </li>
              <li v-if="userAdmin">
                <router-link class="dropdown-item" to="/solicitacoes">
                  <i class="bi bi-person-check me-2"></i>Solicitações
                </router-link>
              </li>
              <li v-if="userAdmin && userEntidade">
                <hr class="dropdown-divider" />
              </li>
              <li v-if="userAdmin">
                <router-link class="dropdown-item" to="/filas">
                  <i class="bi bi-list-task me-2"></i>Filas
                </router-link>
              </li>
              <li v-if="userEntidade">
                <router-link class="dropdown-item" to="/auditoria">
                  <i class="bi bi-journal-text me-2"></i>Auditoria
                </router-link>
              </li>
              <li v-if="userAdmin || userEntidade">
                <hr class="dropdown-divider" />
              </li>
              <li>
                <router-link class="dropdown-item" to="/trocar-senha">
                  <i class="bi bi-key-fill me-2"></i>Trocar senha
                </router-link>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="openLogoutModal"
                >
                  <i class="bi bi-box-arrow-right me-2"></i>Sair
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!-- Logout Confirmation Modal -->
    <div
      class="modal fade"
      id="logoutModal"
      tabindex="-1"
      aria-labelledby="logoutModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="logoutModalLabel">Confirmar Logout</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">Tem certeza de que deseja sair?</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="confirmLogout"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <div class="pendencia-notification poppins-medium" v-if="hasPendencia">
    Seu município está com pendências financeiras e/ou contratuais. O envio de
    arquivos está bloqueado e em breve o acesso será restringido, caso a
    situação não seja regularizada.
  </div>
</template>

<script>
import axiosApi from "@/axios";
import { mapState } from "vuex";

export default {
  name: "Nav",
  data() {
    return {
      showDropdown: false,
      showAvatarDropdown: false,
      hideTimeout: null,
      avatarHideTimeout: null,
    };
  },
  computed: {
    ...mapState([
      "user",
      "userEntidade",
      "nomeMunicipio",
      "isDemo",
      "hasPendencia",
      "isMunicipioChangeable",
    ]),
    userAdmin() {
      return this.user && this.user.role === "admin";
    },
  },
  mounted() {
    // Add window resize listener to adjust dropdown position
    window.addEventListener("resize", this.handleWindowResize);
  },
  beforeUnmount() {
    // Clear any pending timeouts
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    if (this.avatarHideTimeout) {
      clearTimeout(this.avatarHideTimeout);
    }
    // Remove window resize listener
    window.removeEventListener("resize", this.handleWindowResize);
  },
  methods: {
    handleMouseEnter() {
      // Clear any pending hide timeout
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.showDropdown = true;
    },
    handleMouseLeave() {
      // Add a small delay before hiding to prevent flickering
      this.hideTimeout = setTimeout(() => {
        this.showDropdown = false;
        this.hideTimeout = null;
      }, 100);
    },
    handleAvatarMouseEnter() {
      // Clear any pending hide timeout
      if (this.avatarHideTimeout) {
        clearTimeout(this.avatarHideTimeout);
        this.avatarHideTimeout = null;
      }
      this.showAvatarDropdown = true;

      // Adjust dropdown position after it's shown
      this.$nextTick(() => {
        this.adjustDropdownPosition();
      });
    },
    handleAvatarMouseLeave() {
      // Add a small delay before hiding to prevent flickering
      this.avatarHideTimeout = setTimeout(() => {
        this.showAvatarDropdown = false;
        this.avatarHideTimeout = null;
      }, 100);
    },
    adjustDropdownPosition() {
      const dropdown = document.querySelector(".dropdown-menu-end");
      if (!dropdown) return;

      const rect = dropdown.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const rightEdge = rect.right;

      // If dropdown extends beyond viewport, adjust it
      if (rightEdge > viewportWidth) {
        const overflow = rightEdge - viewportWidth + 10; // 10px buffer
        dropdown.style.transform = `translateX(-${overflow}px)`;
      }
    },
    handleWindowResize() {
      // Reset dropdown position on window resize
      const dropdown = document.querySelector(".dropdown-menu-end");
      if (dropdown) {
        dropdown.style.transform = "";
      }

      // If dropdown is currently visible, adjust its position
      if (this.showAvatarDropdown) {
        this.$nextTick(() => {
          this.adjustDropdownPosition();
        });
      }
    },
    openLogoutModal() {
      const modal = new window.bootstrap.Modal(
        document.getElementById("logoutModal")
      );
      modal.show();
    },
    async confirmLogout() {
      try {
        await axiosApi.post("/api/login/logout", {}, { withCredentials: true });
        const modal = window.bootstrap.Modal.getInstance(
          document.getElementById("logoutModal")
        );
        modal.hide();
        document
          .querySelectorAll(".modal-backdrop")
          .forEach((el) => el.remove());
        this.$router.push("/login");
      } catch (error) {
        console.error(
          "Error logging out:",
          error.response ? error.response.data : error.message
        );
      }
    },
  },
};
</script>

<style>
.navbar {
  background-color: var(--azul-escuro);
}

.navbar .navbar-nav .nav-link[href] {
  color: white;
}

.navbar .navbar-nav .nav-item {
  margin-left: 10px;
  margin-right: 10px;
}

.municipio-nome {
  display: flex;
  align-items: center;
}

.nav-item p {
  color: white;
  font-weight: 600;
  font-size: 1.2rem;
  margin: 0;
}
.nav-item .trocar-link {
  font-size: 0.8rem;
}

.modal {
  z-index: 9999;
}

.navbar .dropdown-menu {
  /* background-color: var(--azul-escuro); */
  border: 1px solid var(--azul-escuro);
}

.navbar .dropdown-menu .dropdown-item {
  color: var(--azul-final);
  padding: 8px 16px;
}

.navbar .dropdown-menu .dropdown-item:hover {
  background-color: var(--azul-escuro);
  color: white;
}

.navbar .dropdown-menu .dropdown-item:focus {
  background-color: var(--azul-escuro);
  color: white;
}

/* Improve hover experience */
.navbar .dropdown {
  position: relative;
}

.navbar .dropdown-menu {
  transition: opacity 0.2s ease, visibility 0.2s ease;
  opacity: 0;
  visibility: hidden;
  display: block;
  transform: translateY(-10px);
  transition: all 0.2s ease;
}

.navbar .dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

/* Avatar Dropdown Styles */
.avatar-dropdown {
  padding: 4px 8px !important;
}

.avatar-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.avatar-circle:hover {
  background-color: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.avatar-circle i {
  color: white;
  font-size: 18px;
}

/* Avatar dropdown menu styling */
.navbar .dropdown-menu-end {
  min-width: 200px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: none;
  margin-top: 4px;
  /* Ensure dropdown stays within viewport */
  position: absolute !important;
  right: 0 !important;
  left: auto !important;
  /* Add responsive positioning */
  max-width: calc(100vw - 20px);
  width: max-content;
  /* Prevent overflow */
  overflow: hidden;
  /* Use CSS clamp for responsive width */
  width: clamp(160px, 200px, calc(100vw - 20px));
}

.navbar .dropdown-header {
  color: var(--azul-escuro);
  font-weight: 600;
  font-size: 0.9rem;
  padding: 8px 16px 4px 16px;
}

.navbar .dropdown-divider {
  margin: 4px 0;
  border-color: #e9ecef;
}

.navbar .dropdown-item {
  padding: 8px 16px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
}

.navbar .dropdown-item i {
  width: 16px;
  font-size: 14px;
  color: #6c757d;
  flex-shrink: 0;
}

.navbar .dropdown-item:hover i {
  color: white;
}

/* Remove Bootstrap's default dropdown arrow for avatar */
.avatar-dropdown::after {
  display: none;
}

/* Responsive dropdown adjustments */
@media (max-width: 768px) {
  .navbar .dropdown-menu-end {
    min-width: 180px;
    max-width: calc(100vw - 30px);
    right: 15px !important;
  }

  .avatar-circle {
    width: 35px;
    height: 35px;
  }

  .avatar-circle i {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .navbar .dropdown-menu-end {
    min-width: 160px;
    max-width: calc(100vw - 20px);
    right: 10px !important;
  }

  .navbar .dropdown-item {
    padding: 6px 12px;
    font-size: 0.85rem;
  }
}
</style>
